import { Component, AfterViewInit, OnInit } from '@angular/core';
import { CardComponent } from '../../shared/components/card/card.component';
import { WidgetService } from '../../services/widget.service';
import { GenericService } from '../../services/generic.service';
@Component({
  selector: 'app-register',
  standalone: true,
  imports: [CardComponent],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss'
})
export class RegisterComponent implements AfterViewInit, OnInit {
  constructor(
      private widgetSrv: WidgetService,
      private genericService: GenericService
    ) { }
  ngOnInit(): void {
    this.showWidget();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.genericService.setPlaceholder('#IDToken1', 'Type your username');
      this.genericService.setPlaceholder('#IDToken2', 'Type your first name');
      this.genericService.setPlaceholder('#IDToken3', 'Type your last name');
      this.genericService.setPlaceholder('#IDToken4', 'Enter your email address');
      this.genericService.setPlaceholder('#IDToken5', 'Type your Password');
      this.genericService.setPlaceholder('#IDToken5-confirm', 'Confirm password');
    },1000);
  }

  showWidget() {
    const widget = this.widgetSrv.setWidget('Spark_UserRegistration');
    if(widget) {
      widget
      .subscribe((event) => {
        /* Run anything you want */
        console.log('journey subscriber running')
        console.log(event.journey.successful)
        console.log(event.journey.completed)
        console.log('event.journey.step')
        console.log(event.journey.step?.payload?.callbacks)
      });
    }
  }
}
